import { render, staticRenderFns } from "./AuditListWidget.vue?vue&type=template&id=150d07d0&scoped=true&"
import script from "./AuditListWidget.vue?vue&type=script&lang=js&"
export * from "./AuditListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d07d0",
  null
  
)

export default component.exports